import { createSurveyStyles } from '@sm/webassets';

const useStyles = createSurveyStyles((surveyTheme: any) => ({
  privacyComponentContainer: {
    paddingTop: 80,
    margin: '0 auto',
    textAlign: 'center',
  },
}));

export default useStyles;
